<template>
   <CollapseCard
      title="Qualified R&D Activities"
      :subtitle="`${activities.length} Qualified Activities`"
      ident="activities"
   >
      <div class="d-flex justify-content-end">
         <b-button
            id="btn-configure-activities"
            variant="primary"
            size="sm"
            class="action-btn ml-2"
            :to="{name: 'activities-configure', params: {id: $companyId}}"
         >
            Configure Qualified Activities
         </b-button>
      </div>
      <b-table
         id="table-activities"
         thead-class="table-head"
         :class="[activities.length > 0 ? 'mb-0' : 'mb-5']"
         :fields="[
            {key: 'name', sortable: true},
            {
               key: 'atype',
               label: 'Type',
               formatter: (val) => ActivityType[val],
               sortable: true,
               sortByFormatted: true,
            },
         ]"
         sort-by="name"
         :items="activities"
      >
      </b-table>
   </CollapseCard>
</template>

<script>
import {mapGetters} from 'vuex';
import {ActivityType} from '@/store/modules/activities';

export default {
   data() {
      return {
         ActivityType,
      };
   },

   computed: {
      ...mapGetters({
         activities: 'activities/activities',
      }),
   },
};
</script>
